import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  private superuserSubject = new BehaviorSubject<boolean>(false);
  superuser$ = this.superuserSubject.asObservable();

  private adminSubject = new BehaviorSubject<boolean>(false);
  admin$ = this.adminSubject.asObservable();

  private subadminSubject = new BehaviorSubject<boolean>(false);
  subadmin$ = this.subadminSubject.asObservable();

  private rolesReadySubject = new BehaviorSubject<boolean>(false);
  rolesReady$ = this.rolesReadySubject.asObservable();

  constructor(private keycloak: KeycloakService) {
    this.resolveRolesFromKeycloak();
  }

  private resolveRolesFromKeycloak() {
    try {
      const roles = this.keycloak.getUserRoles(true) || [];
      this.superuserSubject.next(roles.includes('superuser'));
      this.adminSubject.next(roles.includes('admin'));
      this.subadminSubject.next(roles.includes('subadmin'));
    } catch {
      // keycloak not initialised or user not authenticated — leave flags false
    }
    this.rolesReadySubject.next(true);
  }

  setSuperuser(superuser: boolean) {
    this.superuserSubject.next(superuser);
  }

  setAdmin(admin: boolean) {
    this.adminSubject.next(admin);
  }

  setSubadmin(subadmin: boolean) {
    this.subadminSubject.next(subadmin);
  }

  markRolesReady() {
    this.rolesReadySubject.next(true);
  }

    // Getters to retrieve the current state
    get isSuperuser(): boolean {
      return this.superuserSubject.getValue();
    }

    get isAdmin(): boolean {
      return this.adminSubject.getValue();
    }

    get isSubadmin(): boolean {
      return this.subadminSubject.getValue();
    }

}
